import { connect } from 'react-redux';
import MemberSearch from '../components/member_search';
import {
  searchMembers,
  clearMemberSearch,
  selectMemberResult,
  fetchMemberAggregates,
  clearMemberAggregates,
  toggleMemberFavorite,
} from '../actions/member_search_index';

const mapStateToProps = (state) => {
  const { query, results, loading, expandedMemberId, aggregates, aggregatesLoading } = state.memberSearch;

  // favoritesByEvent mirrors localStorage (seeded at boot, updated on
  // TOGGLE_FAVORITE and SYNC_FAVORITES_FROM_STORAGE), so it covers loaded and
  // unloaded events alike without reading localStorage on every dispatch.
  const favoriteMemberIds = new Set(Object.values(state.leaderboardV2.favoritesByEvent).flat());

  return { query, results, loading, expandedMemberId, aggregates, aggregatesLoading, favoriteMemberIds };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onQueryChange: (query) => dispatch(searchMembers(query)),
  onSelect: (participation) => {
    ownProps.onAfterSelect?.();
    dispatch(selectMemberResult({
      eventId: participation.event_id,
      aggregateId: participation.aggregate_id,
      roundId: participation.round_id,
      memberId: participation.member_id,
    }));
  },
  onClear: () => dispatch(clearMemberSearch()),
  onExpandMember: (memberId) => dispatch(fetchMemberAggregates(memberId)),
  onCollapseMember: () => dispatch(clearMemberAggregates()),
  onToggleMemberFavorite: (memberId) => dispatch(toggleMemberFavorite(memberId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MemberSearch);
